<template>
  <div>
    <b-field :label="label">
      <b-input
        v-model="password"
        type="password"
        @input="validatePassword" password-reveal
      ></b-input>
      
    </b-field>
    <p class="help is-danger" v-if="passwordError">{{ passwordError }}</p>
      <p class="help" v-else>Password must have at least 8 characters, 1 letter, 1 number, 1 special character, and 1 capital letter.</p>
    </div>
 </template>
  
  <script>
  export default {
    props: {
      label: String,
      passwordValue: String, 
    },
    data() {
      return {
        password: this.passwordValue, 
        passwordError: '',
      };
    },
    watch: {
      password(newValue) {
        
        this.$emit('update:password-value', newValue);
      },
    },
    methods: {
      validatePassword() {
      const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordPattern.test(this.password)) {
        this.passwordError = 'Password must have at least 8 characters, 1 letter, 1 number, 1 special character, and 1 capital letter.';
      } else {
        this.passwordError = '';
      }
    },
  
    }
  };
  </script>
  